import React from 'react'
import { Modal } from 'react-bootstrap'
import { BsDot } from 'react-icons/bs'
import { Link, useHistory } from 'react-router-dom/cjs/react-router-dom.min'

function MobileDotPopup(props) {
  const history = useHistory();
  
  // const handleBodyClick = () => {
  //   console.log('Modal body clicked, closing modal.');
  //   props?.onHide(); // Close the modal when the body is clicked
  // };
  // debugger;
  // Use originalId for featured services (whose id is prefixed with "salon-"/"staff-"),
  // fall back to id for regular services
  const getServiceId = () => props?.details?.originalId || props?.details?.id;

  const editServiceClick = () => {
    history.push(`/edit-services/${getServiceId()}`)
  }
  
  const editProductClick = (id) => {
    history.push({
      pathname: "/product/editProduct",
      state: { productId: id, product: props?.details }
    })
  }
  // console.log("MobileDotPopupMobileDotPopup",props)
  return (
    <Modal 
    blurClass={props?.blurClass}
    centered={props?.centered}
    show={props?.show} 
    onHide={props?.onHide} 
    backdropClassName={props?.backdropClassName}
    size={props?.size} 
    dialogClassName={props?.dialogClassName} 
    className={props?.className} >
    <Modal.Body className='__dot_popup'  onClick={props?.onHide}>
    {props?.details && <div className='detail' >
       <div className="service-items w-100">
        {props?.type=="Category" ?  <div className="_text">
          <div className="service-header">
            <h4 className='mb-0'><b>{props?.details?.name}</b> </h4>
          </div>
        </div> :
       <div className="_text w-100">
        {/*{console.log("details12312",props?.details)}*/}
              <div className="service-header">
                <h3 className='w-100 d-flex justify-content-between'>
                  <span><b>{props?.details?.productName || props?.details?.name}</b>
                        <span className="__doty"><BsDot /></span>
                        {props?.details?.deposit && <>{props?.details?.deposit} deposit</>}
                        {props?.details?.notAssigned && <span className='_notassign'>Not assigned</span>}</span>
                        <b>
                          {props?.type === "Product"
                            ? `£${props?.details?.retailPrice?.toFixed(2) || '0.00'}`
                            : `£${props?.details?.price?.toFixed(2) || '40.00'}`}
                        </b>
                  </h3>
              </div>
              {props?.type !== "Product" && (
                <p className="_cost">
                  <span><b>{props?.details?.duration}min</b><span className="__doty"><BsDot /></span>
                  {props?.details?.processingTime && <>{props?.details?.processingTime}min processing time</>}
                  {props?.details?.finishingTime ? <> · {props?.details?.finishingTime}min finishing</> : null}
                  </span>
                </p>
              )}
              {props?.type === "Product" && (
                <p className="_cost">
                  <span>
                    {props?.details?.sku && <><b>SKU: {props?.details?.sku}</b></>}
                    {props?.details?.sku && props?.details?.barcode && <span className="__doty"><BsDot /></span>}
                    {props?.details?.barcode && <><b>Barcode: {props?.details?.barcode}</b></>}
                  </span>
                </p>
              )}
              {props?.details?.description && (
                <p className="descption">{props?.details?.description}</p>
              )}
              {props?.type === "Product" && props?.details?.inStock !== undefined && (
                <p className="product-stock-info">
                  <b>In Stock:</b> {props?.details?.inStock || 0}
                </p>
              )}
        </div>
        }
       </div>
       </div>}
      
        {props?.type=="Add" ?
        <div className='_option'>
          <p ><Link to={props?.linkName} className="w-100 d-block">New Service</Link></p> 
          <p onClick={props?.btnClickProps}>New Category</p>
        </div>
         :
         <div className='_option'>
          {props?.type === "Category" ? (
            <p onClick={props?.editOnClickPopup}>Edit {props?.type}</p>
          ) : props?.type === "Product" ? (
            <p onClick={() => editProductClick(props?.details?.id)}>Edit Product</p>
          ) : (
            <p onClick={() => editServiceClick()}>Edit Service</p>
          )}
          <p className='red' onClick={props?.deleteOnClickPopup}>Delete {props?.type}</p>
        </div>
       }
  
       
    </Modal.Body>
</Modal>
  )
}

export default MobileDotPopup